<template>
  <md-card>
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-90">
          <h4 class="title">Extras</h4>
          <p class="category">
            These are the Extras that are available to Customers booking this
            Departure.
          </p>
        </div>
        <div class="md-layout-item md-size-10 text-right">
          <md-button
            class="md-icon-button md-dense md-primary md-round"
            @click.prevent="assignExtra"
          >
            <md-icon>add</md-icon>
            <md-tooltip md-direction="top"
              >Assign an Extra<br />to this Departure</md-tooltip
            >
          </md-button>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <template v-if="extras.length">
        <div
          class="md-layout optional-extra-wrapper"
          v-for="extra in extras"
          :key="extra.title"
        >
          <div class="md-layout-item md-size-50">
            <h6>{{ extra.title }}</h6>
          </div>
          <div class="md-layout-item md-size-50 text-right">
            <md-switch v-model="extra.price_sync">Synced with Parent</md-switch>
          </div>

          <div class="md-layout-item md-size-33">
            <md-field class="md-form-group" slot="inputs">
              <md-icon
                ><i class="fas fa-pound-sign text-primary hi-price-icon"></i
              ></md-icon>
              <label>GBP</label>
              <md-input
                :disabled="extra.price_sync"
                v-model="extra.prices.gbp"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33">
            <md-field class="md-form-group" slot="inputs">
              <md-icon
                ><i class="fas fa-euro-sign text-primary hi-price-icon"></i
              ></md-icon>
              <label>EUR</label>
              <md-input
                :disabled="extra.price_sync"
                v-model="extra.prices.eur"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33">
            <md-field class="md-form-group" slot="inputs">
              <md-icon
                ><i class="fas fa-dollar-sign text-primary hi-price-icon"></i
              ></md-icon>
              <label>USD</label>
              <md-input
                :disabled="extra.price_sync"
                v-model="extra.prices.usd"
                type="text"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-50">
            <md-switch :disabled="extra.price_sync" v-model="extra.compulsory"
              >Compulsory</md-switch
            >
          </div>
          <div class="md-layout-item md-size-50 text-right">
            <md-button
              class="md-just-icon md-simple md-success"
              @click.prevent="updateExtra(extra)"
            >
              <md-icon>save</md-icon>
              <md-tooltip md-direction="top">Update this Extra</md-tooltip>
            </md-button>
            <md-button
              class="md-just-icon md-simple md-danger"
              @click.prevent="removeExtra(extra)"
            >
              <md-icon>remove_circle</md-icon>
              <md-tooltip md-direction="top">Remove this Extra</md-tooltip>
            </md-button>
          </div>
        </div>
      </template>

      <md-empty-state v-else md-label="Nothing to Show">
        <md-button class="md-primary md-raised" @click="assignExtra"
          >Assign an Extra</md-button
        >
      </md-empty-state>
    </md-card-content>

    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Assign an Extra</md-dialog-title>

      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addExtra)">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label for="title">Select an Extra</label>
                <md-select v-model="selectedExtra" name="extra" id="extra">
                  <md-option
                    v-for="availableExtra in availableExtras"
                    :value="availableExtra.id"
                    :key="availableExtra.id"
                    >{{ availableExtra.title }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary" @click="cancel">Cancel</md-button>
            <md-button type="submit" class="md-primary">Assign</md-button>
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </md-card>
</template>

<script>
import departureApi from "@/services/api/departure";
import tourApi from "@/services/api/tour";

import _filter from "lodash/filter";
import Swal from "sweetalert2";

export default {
  props: ["departure"],

  data() {
    return {
      extras: [],
      showDialog: false,
      availableExtras: [],
      selectedExtra: null
    };
  },

  methods: {
    getExtras() {
      departureApi
        .getExtras(this.departure)
        .then(response => {
          this.extras = response.data;
        })
        .catch(err => {});
    },

    getAvailableExtras() {
      tourApi
        .getExtras(this.departure.tour)
        .then(response => {
          this.availableExtras = response.data;
        })
        .catch();
    },

    removeExtra(extra) {
      departureApi
        .removeExtra(this.departure, extra)
        .then(response => {
          this.extras = _filter(this.extras, function(e) {
            return e.id !== extra.id;
          });

          this.$notify({
            timeout: 2500,
            message: "The Extra has been removed.",
            icon: "cancel",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        })
        .catch(err => {});
    },

    assignExtra() {
      this.showDialog = true;
    },

    cancel() {
      this.showDialog = false;
      this.selectedExtra = null;
    },

    addExtra() {
      departureApi
        .assignExtra(this.departure, { extra_id: this.selectedExtra })
        .then(response => {
          this.extras.push(response.data);
          this.cancel();
        })
        .catch();
    },

    updateExtra(extra) {
      departureApi
        .updateExtra(this.departure, extra)
        .then(response => {
          extra.prices = response.data.prices;
          extra.compulsory = response.data.compulsory;
          this.$notify({
            timeout: 2500,
            message: "The Extra has been updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(err => {});
    }
  },

  mounted() {
    this.getExtras();
    this.getAvailableExtras();
  }
};
</script>
<style lang="scss" scoped>
.optional-extra-wrapper {
  border: 1px solid #ddd;
  border-radius: 7px;
  background-color: #f6f6f6;
  margin-bottom: 1em;
}
</style>
